const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
export const AUTH_SESSION_EXPIRED_EVENT = 'auth-session-expired';
export const PORTAL_SESSION_EXPIRED_EVENT = 'seaweeds:portal-session-expired';
export const SESSION_EXPIRED_EVENTS = [
  AUTH_SESSION_EXPIRED_EVENT,
  PORTAL_SESSION_EXPIRED_EVENT,
];

export function resolveApiAssetUrl(value) {
  if (!value || /^data:/i.test(value) || /^https?:\/\//i.test(value)) {
    return value || '';
  }

  const apiOrigin = new URL(API_BASE_URL, window.location.origin).origin;
  const normalizedPath = value.startsWith('/') ? value : `/${value}`;

  return `${apiOrigin}${normalizedPath}`;
}

async function apiRequest(path, options = {}) {
  const authToken = options.token || null;
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    ...(options.headers || {}),
  };

  const response = await fetch(`${API_BASE_URL}${path}`, {
    headers,
    ...options,
  });

  const data = await response.json();

  if (!response.ok) {
    if (response.status === 401 && authToken) {
      window.dispatchEvent(
        new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, {
          detail: {
            message: 'Your session expired. Please login again.',
          },
        })
      );
    }

    throw new Error(data.message || 'Request failed.');
  }

  return data;
}

export default apiRequest;
